"use client";

import { useEffect } from "react";
import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";

import { ProviderProps } from "@/types/util";

import { loginRequest } from "@/lib/auth/msal";

import { HelpDeskProvider } from "@/context/helpDesk";
import { ActiveDirectoryApiProvider } from "@/context/helpDesk/activeDirectory";
import { MultifactorProvider } from "@/context/helpDesk/multifactor";
import { SecurityProvider } from "@/context/helpDesk/security";
import { AuthProvider } from "@/context/util/auth";
import { useUi } from "@/context/util/ui";

import ErrorContent from "@/components/errorContent";
import { SubscriptionProvider } from "@/context/helpDesk/subscription";

export function HelpDeskProviders(props: ProviderProps) {
  const { metadata, setMetadata } = useUi();

  useEffect(() => {
    if (
      props.metadata.needsAuth !== metadata.needsAuth ||
      props.metadata.title !== metadata.title ||
      props.metadata.url !== metadata.url
    )
      setMetadata(props.metadata);
  }, [props.metadata, metadata, setMetadata]);

  if (!metadata.needsAuth) {
    return null;
  }

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      errorComponent={ErrorContent}
    >
      <AuthProvider>
        <MultifactorProvider>
          <ActiveDirectoryApiProvider>
            <SecurityProvider>
              <SubscriptionProvider>
                <HelpDeskProvider>{props.children}</HelpDeskProvider>
              </SubscriptionProvider>
            </SecurityProvider>
          </ActiveDirectoryApiProvider>
        </MultifactorProvider>
      </AuthProvider>
    </MsalAuthenticationTemplate>
  );
}
